import links from "@/constants/links";

/**
 * Get formatted price
 * @param {string} currency
 * @param {string} price
 */
export const toPrice = (currency, price) => `${price} ${currency}`;

/**
 * Get formatted order id
 * @param {string} id
 */
export const toOrderId = (id) => `# ${id}`;

/**
 * Get status phrase
 * @param {object} statuses
 * @param {string} statusId
 */
export const toStatus = (statuses, statusId) => statuses[statusId];

/**
 * Get price per pack
 * @param {number} price
 * @param {number} amount
 */
export const getPricePerPack = (price, amount) => amount > 1 ? price / amount : price;

/**
 * Format transactions the right way
 * @param {object} statuses
 * @param {string} currency
 * @param {object} orders
 */
export const toTransactions = (statuses, currency, orders) => orders.map((order) => ({
    orderId: toOrderId(order.id),
    charName: order.character ? order.character.name : "Unknown",
    packName: order.pack ? order.pack.Name : "Unknown",
    perPackPrice: toPrice(currency, getPricePerPack(order.price / order.amount)),
    totalPrice: toPrice(currency, order.price),
    amount: order.amount,
    status: toStatus(statuses, order.status),
    created: order.created_at,
    hasInvoice: (order.invoicePath != "") ? 1 : 0,
    pdfLink: order.invoicePath ?
        links.endpoints.fileDownload.replace('{fileName}', order.invoicePath) : ""
}));

/**
 * Get all headers for transactions list
 */
export const getHeaders = () => [{
        text: 'Order Id',
        align: 'left',
        sortable: true,
        value: 'orderId'
    },
    {
        text: 'Char Name',
        align: 'left',
        sortable: true,
        value: 'transactionId'
    },
    {
        text: 'Pack Name',
        align: 'left',
        sortable: true,
        value: 'price'
    }, {
        text: 'Per Pack Price',
        align: 'left',
        sortable: true,
        value: 'provider'
    },
    {
        text: 'Amount',
        align: 'left',
        sortable: true,
        value: 'provider'
    }, {
        text: 'Total Price',
        align: 'left',
        sortable: true,
        value: 'points'
    },
    {
        text: 'Status',
        align: 'left',
        sortable: true,
        value: 'status'
    },
    {
        text: 'Created',
        align: 'left',
        sortable: true,
        value: 'created'
    },
    {
        text: 'Invoice',
        align: 'left',
        sortable: true,
        value: 'invoicePath'
    },
]
